import React from 'react';
import { X, Search } from 'lucide-react';

interface MobileSearchDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  query: string;
  onQueryChange: (q: string) => void;
}

export const MobileSearchDrawer: React.FC<MobileSearchDrawerProps> = ({
  isOpen,
  onClose,
  query,
  onQueryChange,
}) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className="md:hidden fixed inset-0 bg-black/50 z-50 fade-backdrop"
        onClick={onClose}
      />

      {/* Full-screen search overlay */}
      <div className="md:hidden fixed inset-x-0 top-0 z-50 bg-white dark:bg-slate-950 safe-top slide-up rounded-b-3xl shadow-2xl px-4 pt-4 pb-6">
        <div className="flex items-center gap-3">
          <div className="flex-1 relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
            <input
              autoFocus
              type="search"
              placeholder="Pesquisar demandas, contatos, protocolos..."
              className="w-full pl-10 pr-4 py-3 bg-slate-100 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-2xl text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
              value={query}
              onChange={(e) => onQueryChange(e.target.value)}
            />
            {query && (
              <button
                onClick={() => onQueryChange('')}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400"
              >
                <X className="w-4 h-4" />
              </button>
            )}
          </div>
          <button
            onClick={onClose}
            className="text-sm font-semibold text-blue-600 dark:text-blue-400 shrink-0"
          >
            Cancelar
          </button>
        </div>

        {query && (
          <p className="text-xs text-slate-400 mt-3 ml-1">
            Pesquisando por "<span className="font-semibold text-slate-600 dark:text-slate-300">{query}</span>"…
          </p>
        )}
      </div>
    </>
  );
};
